import { render, staticRenderFns } from "./DentalClinicalMedia.vue?vue&type=template&id=b608966c&scoped=true"
import script from "./DentalClinicalMedia.vue?vue&type=script&lang=js"
export * from "./DentalClinicalMedia.vue?vue&type=script&lang=js"
import style0 from "./DentalClinicalMedia.vue?vue&type=style&index=0&id=b608966c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b608966c",
  null
  
)

export default component.exports